module.exports = __webpack_public_path__ + "img/a689d98.png";